<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 3C13.5325 3 14.9756 3.38305 16.2387 4.05863L14.2297 5.36259C13.5293 5.12743 12.7796 5 12 5C8.13401 5 5 8.13401 5 12C5 12.7796 5.12743 13.5293 5.36259 14.2297L4.05863 16.2387C3.38305 14.9756 3 13.5325 3 12C3 7.02944 7.02944 3 12 3ZM14.1625 12.9869L20 4L11.0131 9.83754C10.5432 10.1427 10.1427 10.5432 9.83754 11.0131L4 20L12.9869 14.1625C13.4568 13.8573 13.8573 13.4568 14.1625 12.9869ZM21 12C21 10.4679 20.6172 9.02516 19.9419 7.76232L18.6374 9.77032C18.8726 10.4707 19 11.2204 19 12C19 15.866 15.866 19 12 19C11.2204 19 10.4707 18.8726 9.77032 18.6374L7.76232 19.9419C9.02516 20.6172 10.4679 21 12 21C16.9706 21 21 16.9706 21 12ZM10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12Z"
      fill="#636363"
    />
  </svg>
</template>
